export default "__VITE_ASSET__CkEPA97R__"